export const data = {
    data: [
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '64bb898cfcd2b80887170517',
                '64ccc1fc9a3012fb22a692b1',
                '64cd54ef314a69022e2ce3cb',
                '64e4edc45a6906c71eae03fb',
                '64f8b57e3c92a2a679de8c02',
                '64fc27337d9f77b3847b895e',
                '64fc4e307d9f77b384838890',
                '64fc5ebea077adb38676d768',
                '650095bf0717fcd681f03be5',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Lingerie',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['64bbdf590b3b26212eb08253', '650079ccaa1ee8d682dcef4b'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Lingerie',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['64c517b677c04082a5683a18'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay, OnModel',
            },
            data: [
                '64ca85e7f2b185d4b24fc0ab',
                '64f0af507989996d5965b21c',
                '64f0b4830b9cd66e6a710556',
                '64f8c685148d5da677e1f659',
                '64f8c943148d5da677e32a3c',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Kids',
                'csvData.Product Type': 'Kids - Flatlay',
                'csvData.Plus Size': '',
                pendingShootTypes: '',
            },
            data: ['64ccbe95bf1d1afb28779a54'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['64ccc165480fd6fb205af83b', '6501da8505debfe5efd7601b', '6501fa395cb8b5ea259f4f83'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '64cd33e06db9c202282460f4',
                '64e4eceafa1098c7184898b4',
                '64e500525a6906c71eb52fbb',
                '64ff461632a135c955de31d6',
                '6501f3d4604fbbe76d5cd74a',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: '',
            },
            data: ['64d261a48eafbb4c967d68ac', '64d2631f8a07214c95f2b6a9'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Bags',
            },
            data: ['64d27407018d2a5daaea2a22'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['64d279a8e6aac25e5cd60624', '64f9ee5ca26b0caddcff0b09', '64fa1d4f4d3950ade061f160', '64ff6d3925ac69cda7c6d27a'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel, PD_Bags',
            },
            data: [
                '64d64b70d272c0ae53783ce0',
                '64d64c4bd272c0ae537840f1',
                '64d64fe9d272c0ae537852f7',
                '64d654e05b2dafae51505bce',
                '6511d112a2bfaa6f449fb3ee',
                '6511d17ca2bfaa6f449fb6a6',
                '6511d2016586fc6f43888d2b',
                '6511d2742bb4136f4aa2f8af',
                '6511d2de8e9cd36f42139947',
                '6511d3438e9cd36f42139c00',
                '6511d5172bb4136f4aa32c20',
                '6511d6058e9cd36f4213a631',
                '6511d7122bb4136f4aa335c2',
                '6511d79f6586fc6f4388f1bc',
                '6511d8892bb4136f4aa34306',
                '6511d9106586fc6f4388ffb4',
                '6511d97aa2bfaa6f44a0801a',
                '6511d9e4a2bfaa6f44a083ba',
                '6511da426586fc6f43890686',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Bags',
            },
            data: ['64e4d774923ce9c71785c4c6'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Unisex',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Bags',
            },
            data: [
                '64e7809edff1cbfb34ec15aa',
                '64e7941b1c468efb358a1894',
                '64e7b15a416b41fb37871d87',
                '64e7b2df1c468efb358f74c0',
                '64e7b32fdff1cbfb34fb4374',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Shoes',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel, PD_Shoes',
            },
            data: ['64f3295970b6e77b756b55bb'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay',
            },
            data: ['64f7595db3fc9e9a9f734e2c'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Kids',
                'csvData.Product Type': 'Kids - Ghost',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost',
            },
            data: [
                '64f8a1a263c47fa67f5ad225',
                '65086b21e725081a44a6e4cf',
                '6511ad146586fc6f43868bbe',
                '6511ad878e9cd36f4211aa51',
                '6511ae352bb4136f4aa00fdc',
                '6511aea72bb4136f4aa0117d',
                '6511afc36586fc6f4386adab',
                '6511b14e6586fc6f4386b729',
                '6511b3098e9cd36f4211dbc1',
                '6511b5012bb4136f4aa03614',
                '6511b6022bb4136f4aa03c4d',
                '6511b6cca2bfaa6f449d83e6',
                '6511b81b6586fc6f4386fccb',
                '6511b8fe2bb4136f4aa0826f',
                '6511ba092bb4136f4aa0be8d',
                '6511ba932bb4136f4aa0c377',
                '6511bc9d8e9cd36f42125bb5',
                '6511bde36586fc6f43873203',
                '6511cb026586fc6f438845ff',
                '6511ccbb2bb4136f4aa24f2f',
                '6511ceeb2bb4136f4aa2cde4',
                '6511cf92a2bfaa6f449fae0f',
                '6511d2a98e9cd36f421396de',
                '6511d79d8e9cd36f42141661',
                '6511d9d76586fc6f43890454',
                '6511da596586fc6f438907e1',
                '6511e1ee8e9cd36f4214e95a',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel, PD_Bags',
            },
            data: ['64f8be0db77609a678060708'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost',
            },
            data: ['64f9f713a22fd8ade4b0442a'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': '',
                pendingShootTypes: '',
            },
            data: ['64ff465aac2869c95b650d38', '64ff70a825ac69cda7c6e7d0', '64ff718725ac69cda7c6ec0a', '64ff731141201ecd9f82a1b6'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Unisex',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel',
            },
            data: ['6500b8b16db88cd68303000f'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Accessories',
            },
            data: ['6501f96bc726faea26ebfa44'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay, Ghost',
            },
            data: ['6502057deab676eb02e3d3a9'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay, OnModel',
            },
            data: [
                '650572cd752ff9ff882bed17',
                '65057a45c90413ff87edc09a',
                '65057f19c90413ff87edd746',
                '65058300787cc3ff8fdb0e6e',
                '650583c9c90413ff87edec04',
                '65058f40752ff9ff882c7332',
                '650593adc90413ff87ee9876',
                '65059b3b787cc3ff8fdb873b',
                '6511d66e2bb4136f4aa3329e',
            ],
        },
        {
            group: {
                'csvData.Brand Type': null,
                'csvData.Gender': null,
                'csvData.Product Type': null,
                'csvData.Plus Size': null,
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['650572e1c90413ff87eda073'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Accessories',
            },
            data: ['6505a583c90413ff87eed5e5'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel, PD_Accessories',
            },
            data: ['6505a68ec90413ff87eedaec'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel',
            },
            data: ['6505a771cde039ff8950c7ca'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel, PD_Accessories',
            },
            data: ['6505a807c90413ff87eee134', '6505a99bcde039ff8950d1ad', '6505aa6c787cc3ff8fdbbae1'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Lingerie',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '650871edbcd1bd1a42f8ddcb',
                '65087b39e725081a44a7c26c',
                '6511b94b6586fc6f43870556',
                '6511bfd68e9cd36f42128331',
                '6511d781a2bfaa6f44a02eb6',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: '',
            },
            data: [
                '65087403e725081a44a74973',
                '65089ba8e725081a44aa72ab',
                '6509eca7981a3b0777f42db7',
                '650b24132f78192e50f6d8ba',
                '650c7573b909443eee6d758e',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '6508799103a3a91a4ab17642',
                '650885a7e725081a44a827bb',
                '650b3f5bb38b612e484956e3',
                '650c746b9c98dc3ef01cee8e',
                '650c78019c98dc3ef02b64cd',
                '650c7958b909443eee7b9f41',
                '650c7bd69fb0743eef99db02',
                '650c7c3a9fb0743eef9a2530',
                '650c7dabb909443eee7bac84',
                '650c8379ba5d1a3ef688c370',
                '650c86e0ba5d1a3ef688cf64',
                '650c88d6b909443eee7c84e2',
                '650ea823ec766f52614f71c4',
                '650ea99edd2a65525a38ffed',
                '650eab5175bf1f5259bf5221',
                '650eaddcec766f52614fabc2',
                '650eaf05dd2a65525a39262e',
                '650eb089a8f1ab525b2264e2',
                '650eb3c575bf1f5259c20d77',
                '650eb4dd75bf1f5259c2218c',
                '650eb521dd2a65525a3a21a0',
                '650eb8dadd2a65525a3a53ca',
                '6511af756586fc6f438694ef',
                '6511b047a2bfaa6f449d3bf3',
                '6511b5128e9cd36f421205f3',
                '6511b5a16586fc6f4386e9fb',
                '6511bf3d2bb4136f4aa178ad',
                '6511c9246586fc6f43882288',
                '6511cddb2bb4136f4aa2c687',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '65087a9c9597a01a4339811f',
                '650ea8ecec766f52614f76b9',
                '650ea900ec766f52614f784f',
                '650eb2f1dd2a65525a3a171e',
                '650eb87cdd2a65525a3a50d5',
                '650ec213dd2a65525a3addad',
                '650ed064a8f1ab525b25bc21',
                '650ed142dd2a65525a3b763f',
                '650ed4c2ec766f526153c64d',
                '6511ab856586fc6f4386841a',
                '6511ac542bb4136f4aa00708',
                '6511ad696586fc6f43868d9c',
                '6511b088a2bfaa6f449d3db3',
                '6511b0ee8e9cd36f4211c758',
                '6511b1d28e9cd36f4211d2e9',
                '6511b1f22bb4136f4aa01daa',
                '6511b2052bb4136f4aa01f21',
                '6511b31ca2bfaa6f449d4652',
                '6511b3c1a2bfaa6f449d4a03',
                '6511b47a6586fc6f4386c6df',
                '6511b565a2bfaa6f449d70f8',
                '6511b62b8e9cd36f42121060',
                '6511b7d82bb4136f4aa07a94',
                '6511b8608e9cd36f42121fff',
                '6511b8802bb4136f4aa07fad',
                '6511b9108e9cd36f421223cc',
                '6511b9b32bb4136f4aa0bb26',
                '6511ba0e2bb4136f4aa0c081',
                '6511ba6b6586fc6f43871059',
                '6511bae18e9cd36f42123635',
                '6511bb076586fc6f43871822',
                '6511bb526586fc6f43871c5a',
                '6511bba52bb4136f4aa0d30d',
                '6511bbee6586fc6f43871ff7',
                '6511bc8d8e9cd36f42125a42',
                '6511bd25a2bfaa6f449e38ec',
                '6511bd2c8e9cd36f421262a2',
                '6511bdc8a2bfaa6f449e3feb',
                '6511c0288e9cd36f421284da',
                '6511c04c8e9cd36f42128d5a',
                '6511c1508e9cd36f42129901',
                '6511c1542bb4136f4aa18b2f',
                '6511c1c7a2bfaa6f449e6b8d',
                '6511c63ea2bfaa6f449e8961',
                '6511c6f12bb4136f4aa1f435',
                '6511c7e52bb4136f4aa2372b',
                '6511c9eb2bb4136f4aa242ab',
                '6511cb7b2bb4136f4aa24a71',
                '6511cfafa2bfaa6f449faf4a',
                '6511d16b6586fc6f438889eb',
                '6511d2c36586fc6f438891aa',
                '6511d5512bb4136f4aa32da0',
                '6511d6c0a2bfaa6f449fe3c1',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '65087e0203a3a91a4ab1aae0',
                '6508861ee725081a44a8299e',
                '650886d99597a01a433a19bc',
                '650ea5aaec766f52614f6530',
                '650ea673dd2a65525a38e5ca',
                '650ea693ec766f52614f69ba',
                '650ea826ec766f52614f7303',
                '650eae3cdd2a65525a391698',
                '650eaf53dd2a65525a396e07',
                '650eb0b4ec766f526150151f',
                '650eb0f2a8f1ab525b226730',
                '650eb116ec766f5261501964',
                '650eb1c6dd2a65525a39c573',
                '650ecb75a8f1ab525b25783f',
                '650ecf99dd2a65525a3b6739',
                '650ed36fec766f526153b525',
                '6511c55ba2bfaa6f449e85a0',
                '6511cf228e9cd36f42138c10',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Kids',
                'csvData.Product Type': 'Kids - Flatlay',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay',
            },
            data: [
                '650880aae725081a44a7f78b',
                '6511bfa2a2bfaa6f449e5433',
                '6511c0062bb4136f4aa17ef3',
                '6511c0578e9cd36f42128e7d',
                '6511c09e2bb4136f4aa182dc',
                '6511c10fa2bfaa6f449e606a',
                '6511c1836586fc6f43875bc9',
                '6511d205a2bfaa6f449fb9c7',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: '',
            },
            data: ['6508836b03a3a91a4ab1df60', '6508863be725081a44a82b7b'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost',
            },
            data: [
                '650889d8e725081a44a84f1e',
                '6509db302a04e105837b4ba6',
                '6509dc327291a00581725893',
                '6509e4287291a00581729c28',
                '6509e4777291a00581729dc6',
                '6509e7fcb6bfa80585f22786',
                '6511b4ab8e9cd36f4212029e',
                '6511c3932bb4136f4aa197d0',
                '6511d0d2a2bfaa6f449fb1ca',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Kids',
                'csvData.Product Type': 'Kids - Ghost',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay',
            },
            data: ['65088a47e725081a44a85574'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Unisex',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['6509e291b6bfa80585f1b0e6', '6509e7c3b6bfa80585f2256d', '6509ebede538a90776c75644', '6509f50e71cc120778e64f55'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost',
            },
            data: [
                '650b22bc771fe22e4945ee7b',
                '650ead47ec766f52614fa842',
                '650eb3da75bf1f5259c20f14',
                '650ec4f8a8f1ab525b24d9d6',
                '650ecd37dd2a65525a3b568c',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: ['650b26f72f78192e50f6ebe7', '650b2a9f2f78192e50f704b4', '650b2b05771fe22e4947198c', '650b3afb2f78192e50f9ff37'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost',
            },
            data: [
                '650ea81eec766f52614f6ffb',
                '650ea8c275bf1f5259bf47a6',
                '650ead33dd2a65525a391297',
                '650eaf78a8f1ab525b22589e',
                '650eb579a8f1ab525b234f98',
                '650ebe48ec766f526152411b',
                '650ecc6ddd2a65525a3b50ce',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: '',
            },
            data: [
                '650eac7775bf1f5259bf5781',
                '650ece36a8f1ab525b25af43',
                '6511c5de8e9cd36f4212afe1',
                '6511d6f46586fc6f43889c97',
                '6511d880a2bfaa6f44a03aa6',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel',
            },
            data: ['650eb17575bf1f5259c1df5b'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost',
            },
            data: ['650ebb1ea8f1ab525b241e7c', '650ec45d75bf1f5259c32b07'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: '',
            },
            data: ['650ec29275bf1f5259c314bc'],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost',
            },
            data: ['650ec5ed75bf1f5259c3397f', '650ecc4add2a65525a3b4f97'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'OnModel',
            },
            data: ['650ec70a75bf1f5259c3425f'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'OnModel',
            },
            data: [
                '650ec8da75bf1f5259c34a25',
                '650ecaf1a8f1ab525b257358',
                '650ed36175bf1f5259c3e2a5',
                '650ed3f7dd2a65525a3bb716',
                '650ed4a9dd2a65525a3bbf55',
                '650ed9b7ec766f526153eeb6',
                '650eda08dd2a65525a3bdf17',
                '650eda6aa8f1ab525b261e3f',
                '650edb6aa8f1ab525b262735',
                '650edef5a8f1ab525b264220',
                '650edfa8a8f1ab525b264b20',
                '650ee15fec766f5261542e9b',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Apparel',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'OnModel',
            },
            data: ['650eca44dd2a65525a3b3cd6', '650ecaadec766f5261536ef8', '650ecac3dd2a65525a3b4433'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '650ecceeec766f5261537ce9',
                '6511aa272bb4136f4a9ff9ed',
                '6511ac5ca2bfaa6f449d1ab1',
                '6511acd56586fc6f438688af',
                '6511acf4a2bfaa6f449d27a3',
                '6511ae13a2bfaa6f449d303d',
                '6511ae162bb4136f4aa00e5b',
                '6511ae95a2bfaa6f449d3213',
                '6511af32a2bfaa6f449d3446',
                '6511af5b8e9cd36f4211bdec',
                '6511b03aa2bfaa6f449d3a06',
                '6511b0fc6586fc6f4386b531',
                '6511b44a8e9cd36f4211feb9',
                '6511b6ab8e9cd36f421214a4',
                '6511b6b18e9cd36f4212162f',
                '6511bb466586fc6f43871abe',
                '6511bc9f8e9cd36f42125cf0',
                '6511bce86586fc6f43872a94',
                '6511bdad2bb4136f4aa12c1f',
                '6511be80a2bfaa6f449e4d9a',
                '6511bedc8e9cd36f42127d08',
                '6511bf9e2bb4136f4aa17d19',
                '6511c0d8a2bfaa6f449e5ce5',
                '6511c23a2bb4136f4aa18d8e',
                '6511c807a2bfaa6f449f5501',
                '6511c9756586fc6f4388274b',
                '6511cd636586fc6f43885e70',
                '6511d95c8e9cd36f421426a4',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Sports',
                'csvData.Plus Size': 'No',
                pendingShootTypes: '',
            },
            data: ['650ecec9ec766f52615387a4'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Shoes',
            },
            data: [
                '650ed2ada8f1ab525b25d8c2',
                '650edad1a8f1ab525b26233a',
                '650edf3675bf1f5259c46240',
                '650ee5faec766f5261546270',
                '650ee83a75bf1f5259c4c569',
                '6511c212a2bfaa6f449e6d93',
                '6511c2a52bb4136f4aa1918c',
                '6511c31c6586fc6f4387696e',
                '6511c3be6586fc6f43876c96',
                '6511c6166586fc6f43877e57',
                '6511c7376586fc6f438786f2',
                '6511c8488e9cd36f42131d9c',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Flatlay',
            },
            data: [
                '650ed99bdd2a65525a3bdc5d',
                '650edd1ea8f1ab525b262f71',
                '650edd1fa8f1ab525b26303e',
                '650edd8eec766f5261540590',
                '650ee052ec766f526154211f',
                '650ee088a8f1ab525b264e72',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: '',
            },
            data: ['650edaa8ec766f526153f541', '650edb1fa8f1ab525b26248a', '650ede01a8f1ab525b2633ca', '650ee0e3dd2a65525a3c231b'],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Kids',
                'csvData.Product Type': 'Kids - Flatlay',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost',
            },
            data: [
                '6511aaf02bb4136f4aa000a1',
                '6511ad8ca2bfaa6f449d2ae8',
                '6511afd28e9cd36f4211bf35',
                '6511b02c6586fc6f4386b107',
                '6511b0baa2bfaa6f449d3eac',
                '6511b265a2bfaa6f449d434a',
                '6511b2d06586fc6f4386c093',
                '6511b3ce8e9cd36f4211df18',
                '6511b3d38e9cd36f4211e0b9',
                '6511b7296586fc6f4386f2cb',
                '6511b7d86586fc6f4386f9bf',
                '6511b9b16586fc6f43870956',
                '6511bc208e9cd36f4212557c',
                '6511bd5b8e9cd36f42126586',
                '6511c2a12bb4136f4aa1906a',
                '6511c3382bb4136f4aa19501',
                '6511c3a9a2bfaa6f449e7335',
                '6511c4132bb4136f4aa19a92',
                '6511c4a08e9cd36f4212a69e',
                '6511c7612bb4136f4aa2328c',
                '6511c8502bb4136f4aa239b5',
                '6511c99d8e9cd36f42132538',
                '6511ca6e2bb4136f4aa24554',
                '6511caac2bb4136f4aa247ed',
                '6511cc068e9cd36f42137b6b',
                '6511cccd8e9cd36f42138054',
                '6511d165a2bfaa6f449fb57c',
                '6511d4f7a2bfaa6f449fdc51',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': '',
                'csvData.Product Type': '',
                'csvData.Plus Size': '',
                pendingShootTypes: 'Ghost, OnModel',
            },
            data: [
                '6511bbc2a2bfaa6f449def7d',
                '6511c2faa2bfaa6f449e6fb9',
                '6511c61a6586fc6f43877f8f',
                '6511ce622bb4136f4aa2c923',
                '6511d84ba2bfaa6f44a03796',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Male',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Shoes',
            },
            data: [
                '6511c2582bb4136f4aa18ed3',
                '6511c434a2bfaa6f449e762d',
                '6511c4996586fc6f438771b8',
                '6511c5112bb4136f4aa1a149',
                '6511c5838e9cd36f4212ad71',
                '6511c6c56586fc6f438783d4',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Lingerie',
                'csvData.Plus Size': 'No',
                pendingShootTypes: '',
            },
            data: [
                '6511c5808e9cd36f4212ac47',
                '6511d07d6586fc6f43888557',
                '6511d35f2bb4136f4aa2fe11',
                '6511d3d38e9cd36f42139ede',
                '6511d4b18e9cd36f4213a155',
                '6511d628a2bfaa6f449fdef2',
                '6511d687a2bfaa6f449fe004',
                '6511d7fb2bb4136f4aa33af6',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Young',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type B',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Accessories',
            },
            data: [
                '6511cb9c6586fc6f4388482e',
                '6511cc258e9cd36f42137d06',
                '6511cc92a2bfaa6f449f8f6d',
                '6511cd012bb4136f4aa251ad',
                '6511cd4d6586fc6f43885c22',
                '6511cddd2bb4136f4aa2c795',
                '6511ce528e9cd36f421387ff',
                '6511cecd2bb4136f4aa2cc08',
                '6511cf226586fc6f43887f91',
                '6511cf916586fc6f43888194',
            ],
        },
        {
            group: {
                'csvData.Brand Type': 'Mature',
                'csvData.Gender': 'Female',
                'csvData.Product Type': 'Accessories - Type C',
                'csvData.Plus Size': '',
                pendingShootTypes: 'PD_Bags',
            },
            data: ['6511d4358e9cd36f4213a010', '6511d4bc8e9cd36f4213a259', '6511d58d2bb4136f4aa32fa2', '6511d813a2bfaa6f44a033b4'],
        },
    ],
    Fields: [
        {
            key: 'Brand Type',
            path: 'csvData',
            value: ['Young', 'Mature'],
        },
        {
            key: 'Gender',
            path: 'csvData',
            value: ['Kids', 'Male', 'Female', 'Unisex'],
        },
        {
            key: 'Product Type',
            path: 'csvData',
            value: [
                'Kids - Ghost',
                'Kids - Shoes',
                'Kids - Flatlay',
                'Accessories - Type B',
                'Apparel',
                'Accessories - Type C',
                'Sports',
                'Shoes',
                'Lingerie',
            ],
        },
        {
            key: 'Plus Size',
            path: 'csvData',
            value: ['Yes', ''],
        },
    ],
    total: 401,
};
